"use strict";

var _defineProperty = require("/media/konapun/Data/Programming/projects/konapun.github.io/node_modules/@babel/runtime/helpers/defineProperty");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("source-map-support/register");

var _lifecycle = require("../lifecycle");
/**
 * Populate variables such as $$, $0, $1, $#, etc.
 */


var specialVariablesPlugin = function specialVariablesPlugin(_ref) {
  var _ref5;

  var environmentService = _ref.environmentService;
  return _ref5 = {}, _defineProperty(_ref5, _lifecycle.phaseEnum.LOAD_PLUGINS, {
    exit: function exit() {// TODO:
    }
  }), _defineProperty(_ref5, _lifecycle.phaseEnum.PROCESS, {
    exit: function exit(_ref2) {
      var metadata = _ref2.metadata;

      try {
        // FIXME: this will only work for the first command as there's currently no way to extend this at runtime to force a separate positional variable per-command
        var command = metadata.findOne(function (_ref3) {
          var type = _ref3.type;
          return type === metadata.type.COMMAND;
        });
        environmentService.set(0, command.name);
        command.arguments.forEach(function (arg, index) {
          environmentService.set(index + 1, arg);
        });
      } catch (err) {// pass
      }
    }
  }), _defineProperty(_ref5, _lifecycle.phaseEnum.EXECUTE, {
    /**
     * $#: number of command-line arguments
     * $-: current flags
     * $0: command name
     * $1: first arg
     * $2: second arg
     * $3
     * $4
     * $5
     * $6
     * $7
     * $8
     * $9
     * $*: all arguments on the command line
     *
     */
    enter: function enter(_ref4) {
      var command = _ref4.command;
      environmentService.set('!', command.pid); // TODO: should environment state be refreshed every read loop so values can be set readonly?
      // TODO: set positional
    },

    /**
     * $?: exit value of last command
     * $!: pid of last command
     */
    exit: function exit() {
      environmentService.set('?', 0);
    },
    error: function error() {
      environmentService.set('?', 1);
    }
  }), _ref5;
};

var _default = specialVariablesPlugin;
exports.default = _default;